var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isError || _vm.isWarn)?_c('i',{staticClass:"material-icons keyboard-button__sign",class:{'keyboard-button__sign_error': _vm.isError, 'keyboard-button__sign_warning': _vm.isWarn}},[_vm._v("error_outline")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }